import React from "react";
import { UseFormRegisterReturn } from "react-hook-form";
import GenericDropdownField from "../generic-dropdown-field/GenericDropdownField";
import GENDER_SELECT_OPTIONS from "constants/genderSelectOptions";

interface GenderFieldProps {
    register: UseFormRegisterReturn;
    error?: string;
    value?: string;
    disabled?: boolean;
    id?: string;
    fullWidth?: boolean;
}

const GenderField = ({ register, error, value, disabled = false, id, fullWidth = false }: GenderFieldProps) => {
    const width = fullWidth ? "w-full" : "w-[176px] tablet:w-[190px]";

    return (
        <GenericDropdownField
            label="Gender"
            register={register}
            options={GENDER_SELECT_OPTIONS}
            value={value}
            error={error}
            disabled={disabled}
            id={id}
            className={width}
        />
    );
};

export default GenderField;
